// Motivi fissi degli eventi "modificaOrdine" scritti dalle automazioni: il
// backend registra solo campo, valore prima e dopo in DAM_modifiche_ordini.
// L'import tracking sovrascrive un tracking esistente solo quando non e' di 12
// caratteri (vedi importaTrackingDaSource nell'API).
const SPIEGAZIONI = {
  importaTrackingDaSource: {
    N_Trakking:
      "Sovrascritto perché tracking precedente non era a 12 caratteri - probabile segnacollo",
  },
};

export default function spiegazioneModificaOrdine(evento) {
  return SPIEGAZIONI[evento?.funzione]?.[evento?.campoModifica] || null;
}
